import { SentMessageType } from '../../utils/enums';
import type { MessageInList } from '../ChatsList/chatListSlice/types';

export const getLogNotes = (messages: MessageInList[]) => {
  return messages.filter(message => message?.type === SentMessageType.LogNotes);
};
